export const DetailForm = {
  type: 'form',
  formRef: 'detailForm',
  onFinish: 'onSubmitDetailForm',
  onChange: 'DETAIL_FORM_CHANGED',
  children: [
    {
      type: 'div',
      className: 'row',
      children: [
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'input',
              variant: 'number',
              label: '{{REWARD_TYPE_ID}}',
              name: 'reward_type_id',
              extra: '{{REWARD_TYPE_ID_MUST_MATCH_DATA_TEAM}}',
              rules: [{ required: true, message: '{{PLEASE_ENTER_REWARD_TYPE_ID}}' }],
              inputConfig: {
                placeholder: '{{REWARD_TYPE_ID}}',
                size: 'large',
                min: 1,
                precision: 0,
                style: { width: '100%' },
                isDisabled: 'lockedOnUpdate'
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'input',
              label: '{{NAME}}',
              name: 'name',
              rules: [{ required: true, message: '{{PLEASE_ENTER_NAME}}' }],
              inputConfig: {
                placeholder: '{{NAME}}',
                size: 'large'
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'input',
              label: '{{PROGRAM_KEY}}',
              name: 'program_key',
              extra: '{{PROGRAM_KEY_IS_GENERATED_FROM_NAME}}',
              inputConfig: {
                placeholder: '{{PROGRAM_KEY}}',
                size: 'large',
                isDisabled: 'lockedOnUpdate'
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'select',
              label: '{{PROCESSING_FREQUENCY}}',
              name: 'processing_frequency',
              rules: [{ required: true, message: '{{PLEASE_SELECT_PROCESSING_FREQUENCY}}' }],
              inputConfig: {
                placeholder: '{{PROCESSING_FREQUENCY}}',
                size: 'large',
                showSearch: false,
                dataKey: 'frequencyOptions',
                value: 'value',
                label: 'label',
                isDisabled: 'lockedOnUpdate'
              },
              children: [
                {
                  type: 'text',
                  dataKey: 'selectedItem.label'
                }
              ]
            }
          ]
        },
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'input',
              variant: 'datepicker',
              label: '{{START_DATE}}',
              name: 'start_date',
              extra: '{{LEAVE_DATES_EMPTY_FOR_NO_LIMIT}}',
              inputConfig: {
                size: 'large',
                format: 'YYYY-MM-DD',
                style: { width: '100%' },
                placeholder: '{{START_DATE}}'
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-6',
          children: [
            {
              type: 'input',
              variant: 'datepicker',
              label: '{{END_DATE}}',
              name: 'end_date',
              inputConfig: {
                size: 'large',
                format: 'YYYY-MM-DD',
                style: { width: '100%' },
                placeholder: '{{END_DATE}}'
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-12',
          children: [
            {
              type: 'input',
              variant: 'textarea',
              label: '{{DESCRIPTION}}',
              name: 'description',
              inputConfig: {
                placeholder: '{{DESCRIPTION}}',
                rows: 3
              }
            }
          ]
        },
        {
          type: 'div',
          className: 'col-12',
          children: [
            {
              type: 'checkbox',
              name: 'active',
              label: '{{ACTIVE}}',
              className: 'mb-0',
              inputConfig: { initialValue: true }
            }
          ]
        }
      ]
    },
    { //section: submit button
      type: "div",
      className: "d-flex justify-content-end w-100",
      children: [
        {
          type: "button",
          htmlType: "submit",
          buttonType: "text",
          className: "custom-color my-3 ml-auto",
          style: { backgroundColor: "$quaternary", color: "#ffffff" },
          children: [
            {
              type: "text",
              isHide: "hideUpdate",
              content: "{{CREATE}}"
            },
            {
              type: "text",
              isHide: "hideCreate",
              content: "{{UPDATE}}"
            }
          ]
        }
      ]
    }
  ]
}
